import { applicationModuleRegistry, Route } from '@philips-internal/oswald-ui-foundation';
import { ApplicationRoute } from '../../constants/routes';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { Endpoint } from '../../constants/endpoints';

interface ParameterValue {
  paramValue: string
}

export async function setupPhysicianSchedule(): Promise<void> {
  const routes: Route[] = [setupRouteOne()];
  
  HttpService.get<ParameterValue>(Endpoint.GET_DEFAULT_PARAMETER, {
    ieTipoLogin: 5,
    cdFuncao: 9137,
    nrSequencia: 1
  }).then(response => {
    if(response.body?.paramValue === "S") {
      routes.push(setupRouteTwo());
    }
  });

  applicationModuleRegistry.register({
    entry: 'PHYSICIAN_SCHEDULE#9137',
    id: 'PHYSICIAN_SCHEDULE#9137',
    name: 'module.physician_schedule',
    route: ApplicationRoute.PHYSICIAN_SCHEDULE,
    routes: routes,
  });

  function setupRouteOne(): Route {
    return {
      main: true,
      name: 'module.physician_schedule',
      route: ApplicationRoute.PHYSICIAN_SCHEDULE_LIST,
    };
  }
  function setupRouteTwo(): Route {
    return {
      children: [
        {
          name: 'function.clinical-notes-detail',
          route: ApplicationRoute.INTAKES_OUTPUTS_VIEWER,
        },
      ],
      name: 'module.physician_schedule_block',
      route: ApplicationRoute.PHYSICIAN_SCHEDULE_BLOCK_LIST
    }
  }
}
